"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./menu.css");
function Menu() {
    const script = document.createElement("script");
    script.src = "./js/menuScript.js";
    script.async = true;
    script.onload = () => this.scriptLoaded();
    document.body.appendChild(script);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("header", { className: "cd-header" },
            react_1.default.createElement("div", { className: "header-wrapper" },
                react_1.default.createElement("div", { className: "logo-wrap" },
                    react_1.default.createElement("a", { href: "#", className: "hover-target" },
                        react_1.default.createElement("span", null, "your"),
                        "logo")),
                react_1.default.createElement("div", { className: "nav-but-wrap" },
                    react_1.default.createElement("div", { className: "menu-icon hover-target" },
                        react_1.default.createElement("span", { className: "menu-icon__line menu-icon__line-left" }),
                        react_1.default.createElement("span", { className: "menu-icon__line" }),
                        react_1.default.createElement("span", { className: "menu-icon__line menu-icon__line-right" }))))),
        react_1.default.createElement("div", { className: "nav" },
            react_1.default.createElement("div", { className: "nav__content" },
                react_1.default.createElement("ul", { className: "nav__list" },
                    react_1.default.createElement("li", { className: "nav__list-item active-nav" },
                        react_1.default.createElement("a", { href: "#", className: "hover-target" }, "home")),
                    react_1.default.createElement("li", { className: "nav__list-item" },
                        react_1.default.createElement("a", { href: "#", className: "hover-target" }, "studio")),
                    react_1.default.createElement("li", { className: "nav__list-item" },
                        react_1.default.createElement("a", { href: "#", className: "hover-target" }, "news")),
                    react_1.default.createElement("li", { className: "nav__list-item" },
                        react_1.default.createElement("a", { href: "#", className: "hover-target" }, "contact"))))),
        react_1.default.createElement("div", { className: "section full-height over-hide" },
            react_1.default.createElement("div", { className: "switch-wrap" },
                react_1.default.createElement("h1", null, "overlay menu"),
                react_1.default.createElement("div", { id: "switch", className: "hover-target" },
                    react_1.default.createElement("div", { id: "circle" })),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("span", null, "dark"),
                    " - ",
                    react_1.default.createElement("span", null, "light")))),
        react_1.default.createElement("div", { className: 'cursor', id: "cursor" }),
        react_1.default.createElement("div", { className: 'cursor2', id: "cursor2" }),
        react_1.default.createElement("div", { className: 'cursor3', id: "cursor3" })));
}
exports.default = Menu;
